import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Axios from 'axios';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleReset = async () => {
    try {
      await Axios.post("http://localhost:3006/api/reset-password", { token, newPassword });
      alert("Password updated! Redirecting to login...");
      navigate("/");
    } catch (err) {
      setMessage("Link expired or invalid.");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Set New Password</h2>
        <input 
          type="password" 
          placeholder="New Password" 
          className="auth-input"
          onChange={(e) => setNewPassword(e.target.value)} 
        />
        <button onClick={handleReset} className="btn-primary">Update Password</button>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default ResetPassword;